// =============================================================================
// FILE: packages/renderer/src/lib/queryClient.ts
// PURPOSE: Singleton TanStack Query client tuned for IPC traffic — defaults
//          to staleTime 30s so we don't hammer the main process and keep
//          previous data while refetching. Mutations are NOT auto-retried to
//          avoid duplicating side effects.
// =============================================================================

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});
